import Vue from 'vue' ;
import { Component } from 'vue-property-decorator' ;
import { 
    ContentLoader
} from 'vue-content-loader' ;
import LoaderPalette from '../../../../components/loader-palette';


@Component({
    components:{
        ContentLoader
    }
})
class ProfileDeleteLoader extends LoaderPalette {
    constructor(){
        super()
    }
}

export default ProfileDeleteLoader



// WEBPACK FOOTER //
// ./src/containers/profile/loaders/profile-delete-loader/index.ts